"use client";
import Link from "next/link";
import { useState } from "react";

export default function Accordion({ children, className="", open=false, disabled=false }) {
  const [isOpen, set_isOpen] = useState(open)
  return (
    <div className={`accordion-contianer-large${ className}${isOpen?" open":""}${disabled?" disabled":""}`}>
      {children}
      {!disabled && (
        <button className="button-more scaleHover opacity" type="button" onClick={() => {
          set_isOpen((prev) => !prev)
        }}>
          <div className="button-inner">
            {isOpen ? (
              <div className="text">閉じる</div>
            ):(
              <div className="text">続きを見る</div>
            )}
            <i className="icon" />
          </div>
        </button>
      )}
    </div>
  );
}
